import { HttpInterceptorFn } from '@angular/common/http';
import { SKIP_TIMEZONE } from '@one/utils/http-context.utils';

export const timezoneInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_TIMEZONE)) return next(req);

  const timezoneOffset = new Date().getTimezoneOffset();

  const clonedReq = req.clone({
    params: req.params.set('TimeZoneOffset', timezoneOffset.toString())
  });

  return next(clonedReq);
};
